<div class="modal-header">
	<h3 class="modal-title" id="modal-title-id">{{LOCALIZATION.emailAddressSelect}}</h3>
</div>
<div class="modal-body">
	<select [(ngModel)]="selectedValues" name="selectedValues"
		class="form-control email-select" style="display: inline-block;"
		id="notification-emails-list" multiple>
		<option *ngFor="let email of emailsList" [value]="email.email">{{email.name}}</option>
	</select>
</div>
<div class="modal-footer">
	<button class="btn btn-default" type="button" (click)="close()">{{LOCALIZATION.cancel}}</button>
	<button class="btn btn-primary" type="button" (click)="update()">{{LOCALIZATION.submit}}</button>
</div>
